<template>
  <div>
    <div class="w-full">
      <div class="space-y-16">
        <ProductListHeader />
        <div class="sm:px-6 lg:px-8">
          <div class="flex sm:-mx-6 lg:-mx-8">
            <div class="w-64 sm:px-6 lg:px-8">
              <ProductCategories
                :current-product-category-id="currentProductCategoryId"
                @change="switchProductCategory"
              />
            </div>
            <div class="flex-1 flex-col sm:px-6 lg:px-8">
              <Tags ref="tags" :product-tags="tags" :account-id="accountId" @change="updateTags" />
              <div class="grid gap-5 lg:grid-cols-3 lg:max-w-none mt-8">
                <ProductCard
                  v-for="product in filteredProducts"
                  :key="product.id"
                  :product="product"
                  @set-tag="setTag"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';
import { uniq } from 'lodash-es';
import ProductListHeader from '@/components/Products/list/Header.vue';
import ProductCategories from '@/components/Products/list/ProductCategories.vue';
import ProductCard from '@/components/Products/list/ProductCard.vue';
import Tags from '@/components/Products/list/Tags.vue';

export default {
  name: 'AccountProductsView',
  components: {
    ProductListHeader,
    ProductCategories,
    ProductCard,
    Tags,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    fetching: false,
    currentProductCategoryId: null,
    selectedTagIds: [],
  }),
  computed: {
    ...mapGetters('ui/products', ['products']),
    filteredProducts() {
      return this.products.filter((product) => {
        if (this.selectedTagIds.length === 0) {
          return true;
        }

        return this.selectedTagIds.every((tagId) => product.tags.indexOf(tagId) >= 0);
      });
    },
    tags() {
      return uniq(
        this.products.reduce((carry, product) => [...carry, ...(product?.tags || [])], [])
      );
    },
  },
  created() {
    this.fetchData();
  },
  destroyed() {
    this.setIds([]);
    this.setMeta(null);
    this.setLinks(null);
  },
  methods: {
    ...mapActions('ui/products', ['fetchProductList']),
    ...mapMutations('ui/products', ['setIds', 'setMeta', 'setLinks']),
    async fetchProductCategories() {
      try {
        await this.$store.dispatch('ui/productCategories/load');
      } catch (error) {
        //
      }
    },
    async fetchData() {
      this.fetching = true;
      try {
        await this.fetchProductList({
          params: {
            filter: this.getFilter(),
            include: 'media,categories,tags',
            page: {
              size: 500,
            },
          },
        });
      } catch (error) {
        //
      }
      this.fetching = false;
    },
    getFilter() {
      const filter = {};
      if (this.currentProductCategoryId) {
        Object.assign(filter, { has_category: this.currentProductCategoryId });
      }
      if (this.selectedTagIds) {
        Object.assign(filter, { tag_in: this.selectedTagIds });
      }

      return filter;
    },
    switchProductCategory(productCategoryId) {
      this.currentProductCategoryId = productCategoryId;
      this.$refs.tags.clearSelectedTags();
    },
    setTag(tag) {
      if (this.selectedTagIds.indexOf(tag.id) >= 0) {
        return;
      }

      this.$refs.tags.toggleSelected(tag.id);
    },
    updateTags(selectedTagIds) {
      this.selectedTagIds = selectedTagIds;
      this.fetchData();
    },
  },
};
</script>
